/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { AendereEigeneFirmendatenInput } from "../../../../../Management/Mandanten/Commands/AendereEigeneFirmendaten";

export const FELDER_GRUPPEN = ["name", "anschrift", "kommunikation", "rechnungsadresse"] as const;

export type FelderGruppe = typeof FELDER_GRUPPEN[number];
export type FirmendatenName = keyof Omit<
    AendereEigeneFirmendatenInput,
    | "hatRechnungsadresse"
    | "geaendert"
    | "firmendatenId"
    | "mandantId"
    | "anzahlMitarbeitendeId"
    | "schwerpunktId"
    | "mandantBezeichnungAnpassen"
>;
export type Feld = [FirmendatenName, boolean];
